export default __webpack_public_path__ + "media/src/assets/images/LocationBorder-cad5ba9b8f1358a545703b56a1e1dbe6.svg";